import { Module } from 'vuex'
import { VacancyChatState } from './types'
import { getApplication } from '@/api/vacancies/applications/applications'
import LoadableModel from '@/models-ts/LoadableModel'
import VacancyApplication from '@/models-ts/vacancies/VacancyApplication'
import { RootState } from '@/store'

const getInitialState = (): VacancyChatState => ({
  application: new LoadableModel(),
  archiving: false,
})

export default (): Module<VacancyChatState, RootState> => ({
  namespaced: true,
  state: getInitialState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getInitialState())
    },
    setLoading(state) {
      state.application.loading()
    },
    setLoaded(state, application: VacancyApplication) {
      state.application.loaded(application)
    },
    setArchiving(state, flag: boolean) {
      state.archiving = flag
    },
    updateApplication(state, { id, ...fields }: { id: VacancyApplication['id'] } & Partial<VacancyApplication>) {
      if (state.application.value?.id !== id) return

      Object.assign(state.application.value, fields)
    },
  },
  actions: {
    async getApplication({ commit }, applicationId: number) {
      commit('setLoading')
      const application = await getApplication(applicationId)
      commit('setLoaded', VacancyApplication.fromServer(application))
    },
    async updateArchiveApplicationFlag({ commit, dispatch, state }, { applicationId, flag }: { applicationId: number; flag: boolean }) {
      const application = state.application.value
      if (application?.id !== applicationId) return
      if (state.archiving) return

      commit('setArchiving', true)
      try {
        const meta = { ...application.meta, archived: flag }
        await dispatch(
          'vacancyDetails/setApplicationMeta',
          {
            vacancyId: application.vacancyId,
            applicationId: application.id,
            meta,
          },
          { root: true }
        )
        commit('updateApplication', { id: applicationId, meta })
      } finally {
        commit('setArchiving', false)
      }
    },
  },
})
